export default __webpack_public_path__ + "static/media/one-quiet-night-logo.8256d577.jpg";